import { render, staticRenderFns } from "./ImportOrdersTable.vue?vue&type=template&id=6e29f527&scoped=true"
import script from "./ImportOrdersTable.vue?vue&type=script&lang=js"
export * from "./ImportOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29f527",
  null
  
)

export default component.exports